module.exports = __webpack_public_path__ + "img/cloth_g3_hat_15.0731bf41.svg";